import { render, staticRenderFns } from "./release.vue?vue&type=template&id=5b8e8ab4&scoped=true&"
import script from "./release.vue?vue&type=script&lang=ts&"
export * from "./release.vue?vue&type=script&lang=ts&"
import style0 from "./release.vue?vue&type=style&index=0&module=true&lang=stylus&"
import style1 from "./release.vue?vue&type=style&index=1&lang=stylus&"
import style2 from "./release.vue?vue&type=style&index=2&id=5b8e8ab4&scoped=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b8e8ab4",
  null
  
)

export default component.exports